<form [formGroup]="addUserForm" (ngSubmit)="addUserIntoOrganization()" *ngIf="addUserForm">
    <div class="modal-container">
        <div class="modal-header">
            <h4>Add User</h4>
            <a class="close-icon" href="javascript:void()" ngbAutofocus><i class="flaticon2-cross"
                    (click)="ngbActiveModal.close(false)"></i></a>
        </div>
        <div class="modal-body output-lable new-user">
            <div class="row">
                <div class="col-md-12" style="padding: 15px">
                    <div class="email-wrapper mt-4 mb-4">
                        <mat-form-field class="search_field custom-text-field mb-4" [floatLabel]="'never'">
                            <input matInput type="email" placeholder="Enter email" formControlName="user_email" />
                        </mat-form-field>
                        <span class="error-message" *ngIf="addUserForm.get('user_email').hasError('pattern')">Enter
                            valid email address</span><br />
                        <button type="button" class="validate_button btn primary-ebtn" (click)="validateUserAgainstAd()"
                            [disabled]="!addUserForm.get('user_email').valid">
                            Validate
                        </button>
                    </div>
                    <div class="name-wrapper mt-4 mb-4">
                        <div class="input-names-wrapper">
                            <mat-label class="font-style">First Name</mat-label>
                            <mat-form-field [floatLabel]="'never'" class="custom-text-field">
                                <input matInput type="text" placeholder="Enter first name"
                                    formControlName="user_first_name" />
                            </mat-form-field>
                        </div>
                        <div class="input-names-wrapper">
                            <mat-label class="font-style">Last Name</mat-label>
                            <mat-form-field [floatLabel]="'never'" class="custom-text-field">
                                <input matInput type="text" placeholder="Enter last name"
                                    formControlName="user_last_name" />
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="user_role mt-4 mb-4">
                        <div class="user-role-wrapper" *ngIf="true">
                            <h5 class="user-head">User Type</h5>
                            <div class="user-role-dropdown-wr">
                                <mat-select placeholder="Select Role" [(value)]="selectedOptionUserType"
                                    class="dropdown-wrapper" panelClass="dropdown-wrapper" formControlName="user_type">
                                    <mat-option class="option-list" value="{{ role.securityRoleId }}"
                                        *ngFor="let role of organizationUserTypes">{{
                                        role.name
                                        }}</mat-option>
                                </mat-select>
                            </div>
                        </div>
                    </div>
                    <div class="license-switch mt-4 mb-4">
                        <div formGroupName="licenseGroup" class="switch-wrap">
                            <div class="left-toggles">
                                <div class="toggle-wrap mt-4 mb-4" *ngIf="activeOrganization.licenseLimitiDMS > 0">
                                    <mat-label class="slide-toggle-label">IDMS License: </mat-label>
                                    <mat-slide-toggle formControlName="idms_license"></mat-slide-toggle>
                                </div>
                                <div class="toggle-wrap mt-4 mb-4" *ngIf="activeOrganization.licenseLimitICE > 0">
                                    <mat-label class="slide-toggle-label">ICE License: </mat-label>
                                    <mat-slide-toggle formControlName="informate_license"></mat-slide-toggle>
                                </div>
                            </div>
                            <div class="right-toggles">
                                <div class="toggle-wrap mt-4 mb-4">
                                    <mat-label class="slide-toggle-label">CA License: </mat-label>
                                    <mat-slide-toggle formControlName="ca_license"></mat-slide-toggle>
                                </div>
                            </div>
                            <span class="error-message" style="grid-column: 1 / -1;" *ngIf="
                                    this.addUserForm.get('licenseGroup').hasError('requireOneCheckboxToBeChecked') &&
                                    this.addUserForm.get('licenseGroup').touched
                                ">At least one license is required</span>
                        </div>
                    </div>
                    <div class="licenseType-wrapper mt-4 mb-4">
                        <div class="licensetype-sub">
                            <h5 class="license-heading">License Type</h5>
                            <mat-select placeholder="Select License Type" [(value)]="licenseType"
                                class="dropdown-wrapper" panelClass="dropdown-wrapper" formControlName="license_type"
                                [ngClass]="addUserForm.get('license_type').invalid && isAddButtonClicked ? 'custom-error' : ''">
                                <mat-option class="option-list" *ngFor="let license of userLicenseType"
                                    value="{{ license.name }}">{{
                                    license.name
                                    }}</mat-option>
                            </mat-select>
                        </div>
                    </div>
                    <div class="datePicker-wrapper" *ngIf="licenseType === 'Renewal'" mt-4 mb-4>
                        <div class="datepicker">
                            <mat-label>Start Date</mat-label>

                            <dx-date-box class="dx-date-custom-wrapper" formControlName="license_startDate"
                                displayFormat="dd-MMM-yyyy" [inputAttr]="{ 'aria-label': 'Choose Date' }"
                                [min]="currentDate" blockDateTyping>
                            </dx-date-box>
                            <!-- Added 'blockDateTyping' directive to block typing  in dx-datepicker -->
                        </div>
                        <div class="datepicker">
                            <mat-label>End Date</mat-label>

                            <dx-date-box class="dx-date-custom-wrapper" formControlName="license_endDate"
                                displayFormat="dd-MMM-yyyy" [inputAttr]="{ 'aria-label': 'Choose Date' }"
                                [disabled]="true" [min]="currentDate" blockDateTyping>
                            </dx-date-box>
                            <!-- Added 'blockDateTyping' directive to block typing  in dx-datepicker -->
                        </div>
                    </div>
                    <div class="input-wrapper" *ngIf="licenseType === 'Timed'">
                        <div class="timed-wrapper">
                            <mat-label>No. of Days</mat-label>
                            <mat-form-field [floatLabel]="'never'" class="custom-text-field">
                                <input type="number" matInput placeholder="Enter Number Of Days"
                                    formControlName="license_days" autocomplete="off" />
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn secondary-ebtn" (click)="ngbActiveModal.close(false)">Cancel</button>
            <button type="submit" class="btn primary-ebtn" *ngIf="!isAddButton"
                [disabled]="!addUserForm.valid">Add</button>
            <button class="btn primary-ebtn" *ngIf="isAddButton" disabled="true">Add</button>
        </div>
    </div>
</form>